export default {"src":"/_next/static/media/bin.bb9833bb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};